const tags_en = require('./tags.json')
export default tags_en